import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import useGetAllProtocolli from "./utils/useGetAllProtocolli";
import {getAccountInfo} from "../../../utils/GenericUtils";
import {setOpenSnackbar} from "../../../services/AppServices";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {useHistory} from "react-router-dom";
import {AppContext} from "../../../App";
import HideAppBar from "../../widgets/header/HideAppBar";
import {
	Card,
	CardActions,
	CardContent,
	CardHeader, Collapse,
	Container,
	FormControl,
	InputLabel, MenuItem,
	Paper, Select,
	TextField
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import FilterListTwoToneIcon from "@mui/icons-material/FilterListTwoTone";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import ProtocolliDrawer from "./drawer/ProtocolliDrawer";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import {onClickDetails} from "../../../services/AutomationServices";
import ProtocolloCard from "./detail/ProtocolloCard";
import Button from "@mui/material/Button";
import {scaricaProtocolli} from "../../../services/QuaranteneServices";

const GestioneProtocolli = () => {
	const classes = BaseStyle();
	const contattaciClasses = ContattaciStyle();
	const history = useHistory();
	const [value, setValue] = useState("");
	const [open, setOpen] = useState(false);
	const appContext = useContext(AppContext);
	const [stato, setStato] = useState("Da protocollare");// Da gestire - In gestione -  protocollato
	const [pageNumber, setPageNumber] = useState(0);
	const [sort, setSort] = useState("dataUltimaModifica");
	const [dir, setDir] = useState("ASC");
	const {loading, error, protocolli, hasMore} = useGetAllProtocolli(stato, pageNumber, null, sort, dir);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const [selected, setSelected] = useState("")
	
	const observer = useRef();
	
	const setMenuSelected = useCallback((newValue) => {
		setPageNumber(0);
		setStato(newValue);
	}, []);
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore])
	
	const goToProtocollo = useCallback((protocollo) => {
		setSelected(protocollo)
		onClickDetails(protocollo.id, "protocollo", "modify", automationDispatch);
	}, [automationDispatch])
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/protocolli/" + selected.id);
			} else {
				setOpenSnackbar("warning", ("Il protocollo è al momento gestita da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])
	
	useEffect(() => {
		setPageNumber(0);
	}, [sort, dir])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Protocolli"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						
						<Grid item xs={12}>
							<Paper
								className={clsx(classes.roundBorder, classes.filterSearchPaper)}
								component={"section"}>
								<TextField
									placeholder={"Cerca per Codice fiscale e molto altro"}
									value={value}
									onChange={(e) => setValue(e.target.value)}
									autoFocus={true}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton color="inherit" size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										endAdornment: <InputAdornment position="start">
											<Tooltip title={"Ricerca avanzata"}>
												<IconButton color="inherit" onClick={() => setOpen(!open)} size="large">
													<FilterListTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder},
									}}
								/>
								<Collapse in={open} timeout="auto" unmountOnExit>
									<Grid container spacing={3} className={classes.padding2}>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="sort">Ordina per</InputLabel>
												<Select
													labelId="sort"
													id="sort"
													value={sort}
													onChange={(e) => setSort(e.target.value)}
													label="Ordina per"
												>
													<MenuItem value={"dataUltimaModifica"}>Data ultima modifica</MenuItem>
													<MenuItem value={"lastModify"}>Operatore ultima modifica</MenuItem>
													<MenuItem value={"dataCreazione"}>Data creazione</MenuItem>
													<MenuItem value={"dataProtocollo"}>Data protocollo</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="dir">Ascendente / Discendente</InputLabel>
												<Select
													labelId="dir"
													id="dir"
													value={dir}
													onChange={(e) => setDir(e.target.value)}
													label="Ascendente / Discendente"
												>
													<MenuItem value={"ASC"}>Dal più piccolo al più grande</MenuItem>
													<MenuItem value={"DESC"}>Dal più grande al più piccolo</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid>
								</Collapse>
							</Paper>
						</Grid>
						
						<Grid item xs={12}>
							
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>
									
									<ProtocolliDrawer stato={stato} selectMenuItem={setMenuSelected}/>
									
									<div className={classes.content}
									     style={{maxHeight: "80vh", overflowY: "auto", overflowX: "hidden",}}>
										{
											protocolli.map((protocollo, index) => {
												if (protocolli.length === index + 1) {
													return (
														<Card ref={lastTicketElementRef} key={protocollo.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															<ProtocolloCard protocollo={protocollo} goToProtocollo={goToProtocollo}/>
														</Card>
													)
												} else {
													return (
														<Card key={protocollo.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															<ProtocolloCard protocollo={protocollo} goToProtocollo={goToProtocollo}/>
														</Card>
													)
												}
											})
										}
										
										{!loading && !error && protocolli.length === 0 &&
											<Alert severity="info" style={{borderRadius: 24}}>
												<AlertTitle>Evvai 😇!!</AlertTitle>
												Non ci sono protocolli! Goditi questo meritato relax
											</Alert>}
										{!loading && error &&
											<Alert severity="error" style={{borderRadius: 24}}>
												<AlertTitle>Errore</AlertTitle>
												Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
												sviluppatori.
											</Alert>}
										{loading &&
											<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
												<CardHeader
													avatar={<Skeleton variant="circular" height={40} width={40}/>}
													title={<Skeleton width={180}/>}
													subheader={<Skeleton width={260}/>}
													action={<Skeleton variant="circular" height={20} width={20}/>}
													style={{paddingBottom: 2}}
												/>
												<CardContent style={{paddingTop: 0, marginTop: -35}}>
													<Skeleton height={200}/>
												</CardContent>
											</Card>}
									
									</div>
								
								</CardContent>
								<CardActions className={classes.flexRight}>
									<Tooltip
										title={"Scarica i protocolli in csv per la stampa unione. NB: porta pazienza se ci mette un attimo :)"}>
										<Button variant={"contained"} disableElevation size="small" color={"primary"}
										        style={{borderRadius: 24}}
										        className={classes.roundButton} onClick={scaricaProtocolli}>
											<b>Scarica protocolli</b>
										</Button>
									</Tooltip>
								</CardActions>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
        </React.Fragment>
    );
};

export default React.memo(GestioneProtocolli);
